import { render, staticRenderFns } from "./MeitavOpportunisticSavingPopup.vue?vue&type=template&id=6452a527&scoped=true"
import script from "./MeitavOpportunisticSavingPopup.vue?vue&type=script&lang=js"
export * from "./MeitavOpportunisticSavingPopup.vue?vue&type=script&lang=js"
import style0 from "./MeitavOpportunisticSavingPopup.vue?vue&type=style&index=0&id=6452a527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6452a527",
  null
  
)

export default component.exports